<template>
  <div class="part">
    <div class="layout-page-heading">
      <div class="iconClock">
        <img src="../../assets/img/iconPro.png" alt="">
        <el-breadcrumb separator="/">
          <el-breadcrumb-item>项目管理</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
    </div>
    <div class="layout-page-box">
      <el-form :inline="true" label-width="100px" label-position="right" class="search-form">
        <el-form-item label="项目编号">
          <el-input v-model="filters.projectNo" clearable></el-input>
        </el-form-item>
        <el-form-item label="项目名称">
          <el-input v-model="filters.projectName" clearable></el-input>
        </el-form-item>
        <el-form-item label="仪器">
          <el-input v-model="filters.instrumentName" clearable></el-input>
        </el-form-item>
        <el-form-item label="添加人">
          <el-input v-model="filters.createName" clearable></el-input>
        </el-form-item>
        <el-form-item label="区域">
          <el-select :disabled="disabled" v-model="filters.cityCode" clearable>
            <el-option v-for="(item,index) in citys" :key="index" :label="item.name" :value="item.cityCode">
            </el-option>
          </el-select>
        </el-form-item>
        <div class="checkButton">
          <el-form-item label="添加时间">
            <el-date-picker v-model="filters.startTime" type="datetimerange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd HH:mm:ss">
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="query(1)">查询</el-button>
          </el-form-item>
        </div>
      </el-form>
      <div class=" buttonText">
        <div class="delete" @click="del">删除</div>
        <div class="addData" @click="add">新增</div>
      </div>
    </div>

    <div class="layout-page-box">
      <el-table :data="tableData" style="width: 100%" @selection-change="handleSelectionChange" height="460" :header-cell-style="{color:'#626365'}">
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column prop="projectNo" label="项目编号" width="100" align="center"></el-table-column>
        <el-table-column prop="projectName" label="项目名称" width="100"></el-table-column>
        <el-table-column prop="hmProjectName" label="宏脉项目名称" width="100"></el-table-column>
        <el-table-column prop="instrumentNames" label="可用仪器"></el-table-column>
        <!-- <el-table-column prop="positionName" label="部位"></el-table-column> -->
        <el-table-column prop="docotrNames" label="操作人"></el-table-column>
        <el-table-column prop="cityName" label="区域"></el-table-column>
        <el-table-column prop="createTime" label="添加时间"></el-table-column>
        <el-table-column prop="userName" label="添加人"></el-table-column>
        <el-table-column align="center" label="操作">
          <template slot-scope="scope">
            <el-button size="medium" type="primary" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
          </template>
        </el-table-column>
        <el-table-column prop="forbidden" label="禁用" width="80">
          <template slot-scope="scope">
            <el-switch v-model="scope.row.forbidden" active-color="#13ce66" inactive-color="#C9C9C9" :inactive-value="0" :active-value="1" @change="change(scope.$index, scope.row)">
            </el-switch>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination @size-change="handleSizeChange" @current-change="pageChanged" :current-page="filters.pagination.page" :page-size="filters.pagination.limit" :page-sizes="[10, 20, 30, 50]" layout="total, sizes,prev, pager, next, jumper" :total="filters.pagination.total">
      </el-pagination>
    </div>
    <el-dialog :visible.sync="dialogFormVisible" center class="dialogItem" :close-on-click-modal="false">
      <el-form :model="formData" label-width="100px">
        <el-form-item label="区域">
          <el-select multiple @change="handChange" :disabled="disabled" style="width:90%;" v-model="formData.cityCode" clearable placeholder="请选择区域">
            <el-option v-for="item in citys" :key="item.cityCode" :label="item.name" :value="item.cityCode">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="项目名称">
          <el-input v-model="formData.projectName" style="width:90%;"></el-input>
        </el-form-item>
        <el-form-item label="宏脉项目名称">
          <el-input v-model="formData.hmProjectName" style="width:90%;"></el-input>
        </el-form-item>
        <el-form-item label="项目类型">
          <el-select v-model="formData.projectType" placeholder="请选择项目类型" style="width:90%;">
            <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <!-- 根据院区楼层查询可使用仪器 -->
        <el-form-item label="院区/楼层">
          <el-select clearable v-model="formData.areaCode" placeholder="请选择院区" style="width:90%" @change="areaChange" multiple>
            <el-option v-for="(item) in areaOptions" :key="item.areaCode" :label="item.areaName" :value="item.areaCode">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="可用仪器">
          <el-select style="width:90%;" v-model="formData.instrumentNames" @focus="instrumentFocus" @change="instrumentChange" filterable remote clearable placeholder="请输入搜索可用仪器(多选)" multiple>
            <el-option v-for="item in instrumentOptions" :key="item.instrumentId" :label="item.instrumentName" :value="item.instrumentId">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="操作人">
          <el-select style="width:90%;" v-model="formData.docotrNames" @focus="docotrFocus" filterable remote clearable placeholder="请输入搜索部位(多选)" multiple @change="docotrChange">
            <el-option v-for="item in doctorOptions" :key="item.id" :label="item.doctorName" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer partFooter">
        <el-button type="danger" @click="closs()">取 消</el-button>
        <el-button type="primary" @click="doAddgoods()">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "member",
  data() {
    return {
      filters: {
        types: '',
        pagination: {
          page: 1,
          limit: 10,
          total: 0
        },
        startTime: '',
        endTime: '',
      },
      formData: {
        positionName: "",
      },
      tableData: [],
      multipleSelection: [],
      dialogFormVisible: false,
      projectId: '',
      doctorOptions: [],
      instrumentOptions: [],
      positionOptions: [],
      options: [{
        value: '1',
        label: '皮肤'
      }, {
        value: '2',
        label: '注射'
      }, {
        value: '3',
        label: '其他'
      }],
      areaOptions: [],
      floorOptions: [],
      citys: [
        {
          name: '上海',
          cityCode: '1'
        },
        {
          name: '南通',
          cityCode: '2'
        },
      ],
      disabled: false,
      cityCode: Lockr.get('cityCode')
    }
  },
  methods: {
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    pageChanged(page) {
      this.filters.pagination.page = page
      this.refresh()
    },
    handleSizeChange(sizes) {
      this.filters.pagination.limit = sizes
      this.refresh()
    },
    refresh() {
      router.push({
        path: this.$route.path,
        query: _.merge({}, this.$route.query, {
          __query: JSON.stringify(this.pagination)
        }, {
            random: Math.random()
          })
      })
    },
    // 新增项目
    add() {
      this.dialogFormVisible = true
      // 新增置空
      this.formData = {
        cityCode: this.cityCode
      }
      this.projectId = ''
    },
    // 删除项目
    del() {
      var data = this.multipleSelection
      var id = []
      data.map(function (item, index) {
        id.push(item.projectNo)
      })
      this.$confirm('确定要删除选中的数据吗？', '删除项目', {
        center: true
      })
        .then((res) => {
          api.requestQuiet("/project/deleteProject", {
            ids: id.toString()
          }, (res) => {
            if (res.result == true) {
              _g.toast("success", "删除成功")
              this.query(this.filters.pagination.page)
            } else {
              _g.toast("error", "删除失败")
              this.query(this.filters.pagination.page)
            }
          }, (err) => { })
        }).catch((err) => {
          // this.$message.error('删除失败！');
        })

    },
    closs() {
      this.dialogFormVisible = false
    },
    instrumentChange(val) {
      console.log(val)
      this.formData.projectInstrument = val
      // console.log(this.formData.projectInstrument)
    },
    docotrChange(val) {
      this.formData.projectDoctor = val
      // console.log(this.formData.projectDoctor)
    },
    // positionChange(val) {
    //     this.formData.positionId = val
    //     console.log(val)
    //     console.log(this.formData.positionId)
    // },
    // 确定新增
    doAddgoods() {
      console.log(this.formData)
      if (this.formData.projectName == '' || !this.formData.projectName) {
        _g.toast("warning", "请填写项目名称")
        return;
      }
      if (this.formData.instrumentNames == '' || !this.formData.instrumentNames) {
        _g.toast("warning", "请填写仪器名称")
        return;
      }
      // if (this.formData.positionId == '' || !this.formData.positionId) {
      //     _g.toast("warning", "请填写部位名称")
      //     return;
      // }
      if (this.formData.docotrNames == '' || !this.formData.docotrNames) {
        _g.toast("warning", "请填写操作人名称")
        return;
      }
      let empId = Lockr.get("empId")
      if (!this.projectId) {
        // 新增项目接口
        let data = {
          projectName: this.formData.projectName,
          projectType: this.formData.projectType,//新添加的项目分类
          // positionId: this.formData.positionId,
          docotrNames: '',
          instrumentNames: '',
          userId: empId,
          projectDoctor: [{
            doctorId: ""
          }],
          projectInstrument: [{
            instrumentId: ""
          }],
          areaCode: this.formData.areaCode.toString(),
          cityCode: this.formData.cityCode.toString(),
          hmProjectName: this.formData.hmProjectName,
        }
        var list = []
        for (let obj of this.formData.projectInstrument) {
          let resObj = {};
          resObj['instrumentId'] = obj;
          list.push(resObj)
          console.log(resObj)
        }
        data.projectInstrument = list
        console.log(this.formData.projectInstrument)

        var listData = []
        for (let obj of this.formData.projectDoctor) {
          let resObj1 = {};
          resObj1['doctorId'] = obj;
          listData.push(resObj1)
          console.log(resObj1)
        }
        let arrName = []
        this.areaOptions.forEach(ele => {
          this.formData.areaCode.forEach(item => {
            if (item == ele.areaCode) {
              arrName.push(ele.areaName)
              console.log(arrName);
            }
          });
        });
        data.areaName = arrName.toString()
        // this.floorOptions.forEach(ele => {
        //   if (this.formData.floorCode == ele.floorCode) {
        //     data.floorName = ele.floorName
        //   }
        // });
        data.projectDoctor = listData
        console.log(this.formData.projectDoctor)
        api.requestQuiet("/project/insertProjectRelation", data, (res) => {
          if (res.result == true) {
            this.dialogFormVisible = false
            _g.toast("success", "新增成功")
            this.query(this.filters.pagination.page)
          } else {
            this.dialogFormVisible = false
            _g.toast("error", "新增失败")
            this.query(this.filters.pagination.page)
          }
        }, (err) => { })
      } else {
        // 修改项目接口
        let data = {
          id: this.projectId,
          projectName: this.formData.projectName,
          projectType: this.formData.projectType,//新添加的项目分类
          // positionId: this.formData.positionId,
          docotrNames: this.formData.docotrNames.toString(),
          userId: empId,
          instrumentNames: this.formData.instrumentNames.toString(),
          areaCode: this.formData.areaCode.toString(),
          cityCode: this.formData.cityCode.toString(),
          hmProjectName: this.formData.hmProjectName,
          // projectDoctor: [{
          //     doctorId: ""
          // }],
          // projectInstrument: [{
          //     instrumentId: ""
          // }]
        }
        var list = []
        if (this.formData.projectInstrument) {
          for (let obj of this.formData.projectInstrument) {
            let resObj = {};
            resObj['instrumentId'] = obj;
            list.push(resObj)
          }
          data.projectInstrument = list
        }
        if (this.formData.projectDoctor) {
          var listData = []
          for (let obj of this.formData.projectDoctor) {
            let resObj1 = {};
            resObj1['doctorId'] = obj;
            listData.push(resObj1)
          }
          data.projectDoctor = listData
        }
        let arrName = []
        this.areaOptions.forEach(ele => {
          this.formData.areaCode.forEach(item => {
            if (item == ele.areaCode) {
              arrName.push(ele.areaName)
              console.log(arrName);
            }
          });
        });
        data.areaName = arrName.toString()
        // this.floorOptions.forEach(ele => {
        //   if (this.formData.floorCode == ele.floorCode) {
        //     data.floorName = ele.floorName
        //   }
        // });
        api.requestQuiet("/project/updateProjectRelation", data, (res) => {
          if (res.result == true) {
            this.dialogFormVisible = false
            _g.toast("success", "修改成功")
            this.query(this.filters.pagination.page)
          } else {
            this.dialogFormVisible = false
            _g.toast("error", "修改失败")
            this.query(this.filters.pagination.page)
          }
        }, (err) => { })
      }

    },
    handleEdit(index, row) {
      console.log(row);
      this.dialogFormVisible = true
      this.formData = JSON.parse(JSON.stringify(row))
      this.projectId = row.projectNo
      this.formData.projectInstrument = row.instrumentIds.split(',')
      this.formData.projectDoctor = row.docotrIds.split(',')
      let turnNum = function (nums) {
        return nums.map(Number);
      }
      let turnUserDate = turnNum(row.docotrIds.split(','))
      this.formData.instrumentNames = row.instrumentIds.split(',')
      this.formData.docotrNames = turnUserDate
      this.instrumentFocus()
      this.docotrFocus()
      this.formData.positionName = row.positionName
      if (this.formData.cityCode == '1') {
        this.areaOptions = [{
          areaName: '伯思立',
          areaCode: 'bsl'
        }, {
          areaName: '翡立思',
          areaCode: 'fls'
        }]
      } else if (this.formData.cityCode == '2') {
        this.areaOptions = [{
          areaName: '南通伯思立',
          areaCode: 'ntbsl'
        }]
      } else {
        this.areaOptions = [{
          areaName: '伯思立',
          areaCode: 'bsl'
        }, {
          areaName: '翡立思',
          areaCode: 'fls'
        }, {
          areaName: '南通伯思立',
          areaCode: 'ntbsl'
        }]
      }
    },
    // 查询数据列表
    query(page) {
      // console.log(this.filters.startTime)
      var querys = {
        projectNo: this.filters.projectNo,
        projectName: this.filters.projectName,
        instrumentName: this.filters.instrumentName,
        createName: this.filters.createName,
        startTime: '',
        endTime: '',
        page: page,
        size: this.filters.pagination.limit,
        cityCode: this.filters.cityCode,
      }
      if (this.filters.startTime) {
        querys.startTime = this.filters.startTime[0]
        querys.endTime = this.filters.startTime[1]
      }
      // console.log(querys)
      api.requestQuiet('/project/findProjectList', querys, (res) => {
        // console.log(res)
        var data = res.data.list
        this.tableData = data
        this.orgData = data
        this.filters.pagination.total = parseInt(res.data.total)
      }, (err) => { })
    },
    instrumentFocus() {
      console.log(this.formData);
      if (!this.formData.areaCode) {
        let querys = {}
        api.request('/instrument/findByInstruments', querys, (res) => {
          // console.log(res)
          this.instrumentOptions = res.data
        }, (err) => { })
      } else {
        // 院区楼层查询可选仪器
        let querys = {
          areaCode: this.formData.areaCode.toString(),
          // floorCode: this.formData.floorCode,
        }
        api.request('/instrument/findByInstrumentsByArea', querys, (res) => {
          this.instrumentOptions = res.data
        }, (err) => { })
      }
    },
    areaChange(val) {
      this.formData.instrumentNames = ''
      this.$forceUpdate()
    },
    docotrFocus() {
      let data = {
        doctorName: ''
      }
      api.request('/doctor/findDoctors', data, (res) => {
        // console.log(res)
        this.doctorOptions = res.data
      }, (err) => { })
    },
    handChange() {
      this.formData.areaCode = ''
      if (this.formData.cityCode == '1') {
        this.areaOptions = [{
          areaName: '伯思立',
          areaCode: 'bsl'
        }, {
          areaName: '翡立思',
          areaCode: 'fls'
        }]
      } else if (this.formData.cityCode == '2') {
        this.areaOptions = [{
          areaName: '南通伯思立',
          areaCode: 'ntbsl'
        }]
      } else {
        this.areaOptions = [{
          areaName: '伯思立',
          areaCode: 'bsl'
        }, {
          areaName: '翡立思',
          areaCode: 'fls'
        }, {
          areaName: '南通伯思立',
          areaCode: 'ntbsl'
        }]
      }
      this.$forceUpdate()
    },
    change(index, row) {
      let data = {
        id: row.projectId// 0：正常 1：禁用
      }
      api.request("/project/updateProjectInfoForbidden", data, (res) => {
        if (res.result == true) {
          _g.toast("success", "状态修改成功")
          this.query(this.filters.pagination.page)
        } else {
          _g.toast("error", "状态修改失败")
          this.query(this.filters.pagination.page)
        }
      }, (err) => { })
    },

  },
  mounted() {
    /*this.init();*/
    if (this.cityCode && this.cityCode != 'null') {
      this.filters.cityCode = Lockr.get("cityCode")
      this.disabled = true
    } else {
      this.disabled = false
    }
    if (this.cityCode == '1') {
      this.areaOptions = [{
        areaName: '伯思立',
        areaCode: 'bsl'
      }, {
        areaName: '翡立思',
        areaCode: 'fls'
      }]
    } else if (this.cityCode == '2') {
      this.areaOptions = [{
        areaName: '南通伯思立',
        areaCode: 'ntbsl'
      }]
    } else {
      this.areaOptions = [{
        areaName: '伯思立',
        areaCode: 'bsl'
      }, {
        areaName: '翡立思',
        areaCode: 'fls'
      }, {
        areaName: '南通伯思立',
        areaCode: 'ntbsl'
      }]
    }
    this.query(this.filters.pagination.page)
  },
  watch: {
    '$route'(to, from) {
      this.query(this.filters.pagination.page)
    }
  }
}
</script>

<style scoped>
@import "../../assets/css/main.css";

.part >>> .el-dialog--center .el-dialog__body {
  text-align: center;
}

.dialogItem >>> .el-input__inner {
  /* width: 411px; */
  height: 34px;
  background: #ffffff;
  /* box-shadow: 0px 0px 5px 3px #CAEAFD; */
  border-radius: 3px;
  /* border: 1px solid #23A2EE; */
}

.dialogItem >>> .el-form-item__label {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #626365;
  width: 96px;
}

.partFooter >>> .el-button--primary {
  width: 125px;
  height: 34px;
  background: #5a7ef8;
  border-radius: 17px;
  line-height: 5px;
}

.checkButton >>> .el-button--primary {
  width: 98px;
  height: 34px;
  background: #5a7ef8;
  border-radius: 17px;
  line-height: 5px;
}

.partFooter >>> .el-button--danger {
  width: 125px;
  height: 34px;
  border-radius: 17px;
  border: 1px solid #5a7ef8;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #5a7ef8;
  line-height: 2px;
  background: none;
}

.pageInput >>> .el-input__inner {
  width: 400px;
  height: 38px;
  background: #f6f7fb;
  border-radius: 23px;
  border: none;
}

.pageInput >>> .el-button {
  height: 34px;
  border-radius: 17px;
  border: 1px solid #979797;
  line-height: 5px;
  margin-left: 8px;
}
</style>